import { render, staticRenderFns } from "./KYCWizard.vue?vue&type=template&id=45e9c6dc"
import script from "./KYCWizard.vue?vue&type=script&lang=js"
export * from "./KYCWizard.vue?vue&type=script&lang=js"
import style0 from "./KYCWizard.vue?vue&type=style&index=0&id=45e9c6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports